import styled from '@emotion/styled'
import { Checkbox } from 'antd'

export const CheckBoxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: ${({ direction }) => direction};
`
